
































import { defineComponent, Ref, ref, watch, computed, PropType } from '@vue/composition-api'

// components
import { Modal, Select2 } from '@/components/general'

// services
import { EmployeeService } from '@/services/config'

// models
import { IEmployee } from '@/models/config'

// utils
import { getFullNameFormat } from '@/utils'
import { isWorkingInDate } from '@/utils/employee'

export default defineComponent({
  name: 'ModalAddSupportStaff',
  components: {
    Modal,
    Select2
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    headquarter: {
      type: Number,
      default: null
    },
    employeeIdExcept: {
      type: Array as PropType<number[]>,
      required: true
    },
    date: {
      type: String
    }
  },
  setup (props, { emit }) {
    const hide = () => {
      emit('hide')
    }
    const employeeSelected: Ref<number|null> = ref(null)
    const employees: Ref<IEmployee[]> = ref([])
    const idsExcept: Ref<number[]> = ref([])

    idsExcept.value = props.employeeIdExcept

    const getAll = async () => {
      idsExcept.value = props.employeeIdExcept
      employees.value = await EmployeeService.getAll({
        headquarters: props.headquarter,
        name: '',
        position: null,
        workCategory: null,
        typeContract: null,
        area: null,
        subArea: null,
        workType: null,
        status: true
      })
    }
    const employeesOp = computed(() => {
      return employees.value.filter(e => {
        const exists = idsExcept.value.find(eId => eId === Number(e.id))
        return !exists
      }).filter(e => isWorkingInDate(e, String(props.date))).map(e => {
        return {
          text: getFullNameFormat(e),
          value: e.id
        }
      })
    })
    const addEmployee = () => {
      if (employeeSelected.value) {
        const employee = employees.value.find(e => e.id === employeeSelected.value)
        emit('employee-selected', employee)
      }
    }
    watch(
      () => props.show,
      (newShow) => {
        if (newShow && props.headquarter > 0) {
          getAll()
        } else {
          employees.value = []
          employeeSelected.value = null
        }
      }
    )
    return {
      hide,
      employeesOp,
      employeeSelected,
      addEmployee
    }
  }
})
